var _dec, _dec2, _class;

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Component, classMap, html } from '@sick-davinci/ce-decorators';
import { style } from './SearchField.style';
import { icon_search } from '@sick-davinci/material-icons/action/search.icon';
import { icon_close } from '@sick-davinci/material-icons/navigation/close.icon';
import { DropDown } from '../drop-down/DropDown';
/**
 *  A `davinci-search-field` is a specialization of a `davinci-drop-down` list.
 *  But it's always editable and highlights the input in the dropdown list.
 *  It enables the user to find words, sentences and numbers in a collection of data.
 *  However you can customize the styling and highlighting via contentRenderer.
 *  Use the data property for setting the dropdown list.
 * 
 * @example
 * ```html
 * <davinci-search-field 
 *   id="searchfield" 
 *   placeholder="Search for fruit">
 * </davinci-search-field>
 * <script>
 *   const data = ["Banana", "Strawberry", "Cherry,", "Pine-apple", "Apple", "Peach", "Mango", "Pear"];
 *   const searchField = document.getElementById('searchfield');
 *   searchField.addEventListener('input', function(event) {
 *     searchField.expanded = true;
 *     searchField.data = data.filter(function(value){ return value.toLowerCase().indexOf(event.detail.toLowerCase()) >= 0});
 *   });
 * </script>
 *  ```
 * @slot { davinci-option[] } `davinci-option` elements to define the dataset for the search field
 * @slot { davinci-option-group[] } `davinci-option-group` elements to define a grouped dataset for the the search field
 */

export let SearchField = (_dec = Component({
  tag: 'davinci-search-field',
  style: [style],
  inheritStyle: true,
  dependencies: [DropDown]
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec(_class = _dec2(_class = class SearchField extends DropDown {
  constructor() {
    super();

    this.search = () => {
      this.change.emit(this.internalValue);
    };

    this.clear = () => {
      this.value = '';
      this.input.emit(this.internalValue);
      this.shadowRoot.querySelector('input').focus();
    };

    this.editable = true;
  }

  renderContainerContent() {
    return html`
        <davinci-icon-ref .src="${icon_search}" @click="${this.search}"></davinci-icon-ref>
        ${this.renderInput()}
        <davinci-icon-ref class="${classMap({
      clear: true,
      hidden: !this.value
    })}" .src="${icon_close}" @click="${this.clear}"></davinci-icon-ref>
    `;
  }
  /**
   * Emits the value similiar to the change event.
   * Emmitted if clicked on the blue magnifier icon.
   */


}) || _class) || _class);
